import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { type SxProps, type Theme } from '@mui/material';
import { type ModalContentProps } from '@/core/features/modal';

import styles from './styles';

type Props = {
  children: React.ReactNode;
  title: string;
  closeModal: ModalContentProps['closeModal'];
  onAccept?: () => void;
  acceptText?: string;
  onCancel?: () => void;
  cancelText?: string;
  bodySx?: SxProps<Theme>;
};

const ModalLayout = ({
  children,
  title,
  closeModal,
  onAccept,
  acceptText = 'OK',
  onCancel,
  cancelText = 'Cancel',
  bodySx,
}: Props) => (
  <Box sx={styles.root}>
    <Box sx={styles.header}>
      <Typography sx={styles.title}>{title}</Typography>

      <IconButton sx={styles.icon}>
        <CloseIcon onClick={closeModal} />
      </IconButton>
    </Box>

    <Box sx={{ ...styles.body, ...bodySx }}>{children}</Box>

    {(onAccept || onCancel) && (
      <Box sx={styles.actions}>
        {onCancel && (
          <Button
            size="small"
            color="info"
            variant="outlined"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
        )}

        {onAccept && (
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={onAccept}
          >
            {acceptText}
          </Button>
        )}
      </Box>
    )}
  </Box>
);

export default ModalLayout;
